import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CmpsScorecardSubHeaderData } from './scorecard-sub-header.metadata';

@Component({
    selector: 'cmps-scorecard-sub-header',
    template: `
        <div class="cmps-scorecard-sub-header--container">
            <div class="cmps-scorecard-sub-header--period-type">
                <select
                    class="cmps-scorecard-sub-header--menu"
                    [disabled]="disabled"
                    [ngModel]="selected"
                    (ngModelChange)="
                        selected = $event; selectedAction.emit($event)
                    "
                >
                    <option *ngFor="let i of options">
                        {{ i.value }}
                    </option>
                </select>
                <cmps-icon svgIcon="__internal:chevron-down"></cmps-icon>
            </div>
            <span class="cmps-scorecard-sub-header-time-period">
                {{ timePeriod }}
            </span>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-sub-header',
    },
})
export class CmpsScorecardSubHeaderComponent {
    @Input() superGroupLabel: string;
    @Input() superGroupValue: string;
    @Input() timePeriod: string;

    @Input() selected: string;
    @Input() disabled: boolean;
    @Input() options: CmpsScorecardSubHeaderData[];

    @Output() selectedAction: EventEmitter<string>;

    constructor() {
        this.selectedAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.selectedAction.complete();
    }
}
